export const SERVICE_PLAN_PHOTO = 1;
export const SERVICE_PLAN_FREE = 2;
export const SERVICE_PLAN_STANDARD = 4;
export const SERVICE_PLAN_NOTOPEN = 6;
export const SERVICE_PLAN_SUSPENDED = 7;
export const SERVICE_PLAN_ARCHIVED = 8;